var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"rules":_vm.rules,"type":"text","label":_vm.label,"outlined":"","clearable":""},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }